import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";

export function loadCategoriesSuccess(articleCategories, filterDeleted = false) {
    return {type: types.LOAD_ARTICLE_CATEGORIES_SUCCESS, articleCategories, filterDeleted};
}

export function createArticleCategorySuccess(category) {
    return {type: types.CREATE_ARTICLE_CATEGORY_SUCCESS, category}
}

export function updateArticleCategorySuccess(category) {
    return {type: types.UPDATE_ARTICLE_CATEGORY_SUCCESS, category}
}

export function getArticleCategorySuccess(category) {
    return {type: types.GET_ARTICLE_CATEGORY_SUCCESS, category}
}

export function resetArticleCategory() {
    return {type: types.RESET_ARTICLE_CATEGORY}
}

export function deleteArticleCategorySuccess(category) {
    return {type: types.DELETE_ARTICLE_CATEGORY_SUCCESS, category}
}

export function reactivateArticleCategorySuccess(category) {
    return {type: types.REACTIVATE_ARTICLE_CATEGORY_SUCCESS, category};
}

export function loadCategories(params = {}, filterDeleted = false) {

    console.log(filterDeleted);

    params.active = filterDeleted;


    console.log(params);

    return function (dispatch) {
        return PrivateAPIResource.all('article-categories', params).then(articleCategories => {
            dispatch(loadCategoriesSuccess(articleCategories, filterDeleted))
        }).catch(error => {
            throw  error;
        });
    }
}

export function getArticleCategory(id) {
    return function (dispatch) {
        return PrivateAPIResource.get('article-categories', id).then(category => {
            dispatch(getArticleCategorySuccess(category));
        }).catch(error => {
            throw error;
        });
    }
}

export function saveArticleCategory(category) {
    return function (dispatch, getState) {
        return PrivateAPIResource.create('article-categories', category).then(category => {
            dispatch(createArticleCategorySuccess(category));
        }).catch(error => {
            throw error;
        })
    }
}

export function updateArticleCategory(category, id) {
    return function (dispatch) {
        return PrivateAPIResource.update('article-categories', id, category).then(category => {
            dispatch(updateArticleCategorySuccess(category));
        }).catch(error => {
            throw error;
        })
    }
}

export function deleteArticleCategory(id) {
    return function (dispatch) {
        return PrivateAPIResource.remove('article-categories', id).then((category) => {
            dispatch(deleteArticleCategorySuccess(category));
        }).catch(error => {
            throw error;
        })
    }
}

export function reactivateArticleCategory(id) {
    return function (dispatch) {
        return PrivateAPIResource.update('article-categories/reactivate', id, {}).then((category) => {
            dispatch(reactivateArticleCategorySuccess(category));
        }).catch(error => {
            throw error;
        })
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/articleCategoryActions.js